<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import Flickity from "flickity";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      carousel: null,
      currentSlideIndex: null,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      if (!!this.content.items && this.content.items.length > 0) {
        const cmp = this;
        this.carousel = new Flickity(this.$refs["flickity-carousel-banners"], {
          draggable: ">1",
          pageDots: true,
          cellAlign: "center",
          prevNextButtons: false,
          wrapAround: true,
          imagesLoaded: true,
          arrowShape: { 
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
          },
          on: {
            ready: function() {
              cmp.currentSlideIndex = 0;
            },
            change: function( index ) {
              cmp.currentSlideIndex = index;
            },
          }
        });
      }
    });
  },
}
</script>

<template>
  <div v-easyadmin="easyadminId" class="container-fluid py-5" :style="{'background-color': content.background_color}" :class="contentType" :id="easyadminId" list-carousel-banners-component>
    <div class="row">
      <div class="col-12">
        <div class="container">
          <div class="flickity-carousel-banners w-100 text-center" ref="flickity-carousel-banners">
            <div
              v-for="(item, index) in content.items"
              class="flickity-carousel-banners-item"
              :key="`carousel-banners-slide-${index}`"
              :id="`carousel-banners-slide-${index}`"
              :class="{'is-selected': index === 0, 'pb-3': content.flickity_dots}"
              :ref="`carousel-banners-slide-${index}`"
            >
              <component :is="item.layout || 'stripe-one-col-text'" :content="item" :opt-container-content="containerContent"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-carousel-banners-component] {
  .flickity-carousel-banners-item {
    width: 100%;
  }

  .flickity-page-dots {
    bottom: -44px;
  }

  .flickity-page-dots .dot {
    width: 1rem;
    height: 1rem;

    &.is-selected {
      background-color: $puke-yellow;
    }
  }
}
</style>